/* eslint-disable camelcase */
import axios from "axios";
import { requiredParam } from "@utils/func";

const costCenterSchema = {
  company: "company",
  country: "country",
  invoiceCurrency: "invoice_currency",
  costCenterName: "cost_center_name",
  addressLine1: "address_line_1",
  addressLine2: "address_line_2",
  city: "city",
  postalCode: "postal_code",
  vatNumber: "vat_number",
  billingEmail: "billing_email",
  billingEmail2: "billing_email_2",
  billingEmail3: "billing_email_3",
  billingEmail4: "billing_email_4",
  bankName: "bank_name",
  bankAddressLine: "bank_address_line",
  swiftCode: "swift_code",
  ibanCode: "iban_code",
  accountNumber: "account_number",
  invoiceBatching: "invoice_batching",
  specialProcedures: "special_percedures",
  wantRenewalNotifications: "want_renewal_notifications",
  primaryUser: "primary_user",
};

const getCompanyCostCenters = ({ companyId = requiredParam("companyId") }) => {
  return axios.get(`companies/${companyId}/cost-centers`);
};

const postCompanyCostCenter = ({
  company = requiredParam("company"),
  country = requiredParam("country"),
  invoiceCurrency = requiredParam("invoiceCurrency"),
  costCenterName = requiredParam("costCenterName"),
  addressLine1 = requiredParam("addressLine1"),
  addressLine2 = "",
  city = requiredParam("city"),
  postalCode = requiredParam("postalCode"),
  vatNumber = "",
  billingEmail = requiredParam("billingEmail"),
  billingEmail2 = "",
  billingEmail3 = "",
  billingEmail4 = "",
  bankName = "",
  bankAddressLine = "",
  swiftCode = "",
  ibanCode = "",
  accountNumber = "",
  invoiceBatching = "",
  specialProcedures = "",
  wantRenewalNotifications = true,
  primaryUser = "",
} = {}) => {
  const data = {
    company,
    country,
    invoice_currency: invoiceCurrency,
    cost_center_name: costCenterName,
    address_line_1: addressLine1,
    address_line_2: addressLine2,
    city,
    postal_code: postalCode,
    vat_number: vatNumber,
    billing_email: billingEmail,
    billing_email_2: billingEmail2,
    billing_email_3: billingEmail3,
    billing_email_4: billingEmail4,
    bank_name: bankName,
    band_address_line: bankAddressLine,
    swift_code: swiftCode,
    iban_code: ibanCode,
    account_number: accountNumber,
    invoice_batching: invoiceBatching,
    special_percedures: specialProcedures,
    want_renewal_notifications: wantRenewalNotifications,
    primary_user: primaryUser,
  };

  return axios.post("cost-centers", data);
};

const patchCompanyCostCenter = ({
  costCenterId = requiredParam("costCenterId"),
  data = requiredParam("data"),
} = {}) => {
  const formattedData = {};

  Object.keys(costCenterSchema).forEach((key) => {
    if (data[key]) {
      formattedData[costCenterSchema[key]] = data[key];
    }
  });

  return axios.patch(`cost-centers/${costCenterId}`, formattedData);
};

export { getCompanyCostCenters, postCompanyCostCenter, patchCompanyCostCenter };
